<script>
export default {
    name: 'FlagGermany',
}
</script>
<template>
    <svg
        class="base-flag flag-germany"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs>
            <path id="a" d="M0 0h28v20H0z" />
            <path id="d" d="M0 6.667h28v6.667H0z" />
            <path id="f" d="M0 13.333h28V20H0z" />
            <filter
                id="c"
                width="110.7%"
                height="145%"
                x="-5.4%"
                y="-22.5%"
                filterUnits="objectBoundingBox"
            >
                <feMorphology
                    in="SourceAlpha"
                    operator="dilate"
                    radius=".5"
                    result="shadowSpreadOuter1"
                />
                <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                <feColorMatrix
                    in="shadowOffsetOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                />
            </filter>
            <filter
                id="e"
                width="110.7%"
                height="145%"
                x="-5.4%"
                y="-22.5%"
                filterUnits="objectBoundingBox"
            >
                <feMorphology
                    in="SourceAlpha"
                    operator="dilate"
                    radius=".5"
                    result="shadowSpreadOuter1"
                />
                <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                <feColorMatrix
                    in="shadowOffsetOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                />
            </filter>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <use fill="#FFF" xlink:href="#a" />
            <path fill="#262626" d="M0 0h28v6.667H0z" mask="url(#b)" />
            <g mask="url(#b)">
                <use fill="#000" filter="url(#c)" xlink:href="#d" />
                <use fill="#F01515" xlink:href="#d" />
            </g>
            <g mask="url(#b)">
                <use fill="#000" filter="url(#e)" xlink:href="#f" />
                <use fill="#FFD521" xlink:href="#f" />
            </g>
        </g>
    </svg>
</template>
